import { z } from 'zod'
import {
  warehouseDecimal,
  warehouseFileSchema,
  warehousePositive,
  warehouseVersion,
} from './warehouse.ts'

const text = z.string().trim().min(1).max(500)
const date = z.iso.date()
/**
 * «Потрібно закупити»: a catalogue material, or free text with its own unit when the material is
 * not in the catalogue yet. A material quantity may be in any of its units (base or conversion);
 * the server converts it to the base unit.
 */
export const purchaseRequestSchema = z
  .object({
    materialId: text.nullable(),
    title: z.string().trim().max(200).nullable().optional(),
    quantity: warehousePositive,
    unit: z.string().trim().min(1).max(32).nullable().optional(),
    reason: z.string().trim().max(500).optional().default(''),
    orderNumber: z.string().nullable(),
    dealId: z.string().trim().min(1).max(200).nullable().optional(),
    neededBy: date.nullable().optional(),
  })
  .strict()
  .refine((value) => Boolean(value.materialId) || Boolean(value.title?.trim() && value.unit), {
    message: 'Оберіть матеріал або опишіть, що купити, і вкажіть одиницю',
  })
export const purchaseTransitionSchema = z.object({ version: warehouseVersion }).strict()
const versions = z.record(z.string(), warehouseVersion)
export const supplyVersionsSchema = z.object({ versions }).strict()
export const supplyOrderSchema = z
  .object({
    attachments: z.array(warehouseFileSchema).optional(),
    supplier: z.string().trim().max(500),
    buyerEntityId: z.string().nullable(),
    lines: z
      .array(
        z
          .object({ materialId: text, quantity: warehousePositive, unitCost: warehouseDecimal })
          .strict(),
      )
      .min(1),
    warehouse: text,
    location: z.string().nullable(),
    expectedAt: date.nullable(),
    invoice: z.string().nullable(),
    requestIds: z.array(z.string()),
    payment: z.object({ dueAt: date }).strict().nullable(),
  })
  .strict()
export const supplyUpdateSchema = z
  .object({
    attachments: z.array(warehouseFileSchema).optional(),
    supplier: z.string().trim().max(500),
    expectedAt: date.nullable(),
    warehouse: text,
    invoice: z.string().nullable(),
    versions,
  })
  .strict()
export const supplyPaymentSchema = z
  .object({ invoice: text, dueAt: date, buyerEntityId: text, versions })
  .strict()
